export enum FelloVisitorUserType {
  HOME_OWNER = "HOME_OWNER",
  AGENT = "AGENT"
}
